var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcSearch2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_256_588)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.5038 20.9967C7.70693 20.9967 3.0076 16.2974 3.0076 10.5005C3.0076 4.70359 7.70688 0.00436401 13.5038 0.00436401C19.3007 0.00436401 24 4.70364 24 10.5006C24 16.2975 19.3007 20.9967 13.5038 20.9967ZM13.5038 3.00329C9.36315 3.00329 6.00653 6.35991 6.00653 10.5006C6.00653 14.6412 9.36315 17.9978 13.5038 17.9978C17.6444 17.9978 21.0011 14.6412 21.0011 10.5006C21.0011 6.35991 17.6444 3.00329 13.5038 3.00329Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.50812 23.9956C1.10955 23.9979 0.726476 23.8414 0.443515 23.5608C-0.144477 22.9776 -0.148353 22.0282 0.434832 21.4402C0.437726 21.4373 0.440621 21.4344 0.443515 21.4315L6.08145 15.7936C6.69012 15.2056 7.6602 15.2224 8.24819 15.8311C8.83618 16.4397 8.81938 17.4098 8.21072 17.9978L2.57273 23.5608C2.28977 23.8414 1.9067 23.9979 1.50812 23.9956V23.9956Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_256_588"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSearch2);
export default __webpack_public_path__ + "static/media/ic_search (2).f3c641e1aadde26168f67cdc78bbf09a.svg";
export { ForwardRef as ReactComponent };